const PasswordValidationInvalidIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
      <g clipPath="url(#clip0_927_12182)">
        <path d="M8 4.5V8.5H4V4.5H8Z" stroke="white" strokeWidth="8" />
        <path
          d="M6 0.5C2.682 0.5 0 3.182 0 6.5C0 9.818 2.682 12.5 6 12.5C9.318 12.5 12 9.818 12 6.5C12 3.182 9.318 0.5 6 0.5ZM9 8.654L8.154 9.5L6 7.346L3.846 9.5L3 8.654L5.154 6.5L3 4.346L3.846 3.5L6 5.654L8.154 3.5L9 4.346L6.846 6.5L9 8.654Z"
          fill="#D1D4D6"
        />
      </g>
      <defs>
        <clipPath id="clip0_927_12182">
          <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PasswordValidationInvalidIcon;
